import { render, staticRenderFns } from "./CustomRadio.vue?vue&type=template&id=9996b010&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=ts"
export * from "./CustomRadio.vue?vue&type=script&lang=ts"
import style0 from "./CustomRadio.vue?vue&type=style&index=0&id=9996b010&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9996b010",
  null
  
)

export default component.exports